import React, { useContext, useState, useEffect } from 'react';
import { api } from "../../helpers/api";
import { format } from "date-fns";
import useWindowDimensions from "../../helpers/useWindowDimensions";
import NumberFormat from 'react-number-format';
import moment from 'moment';
import { ModalWebPagos, CustomModal as Modal,} from "../modal/Modal"
import { TextColored, Text, Title } from "../typography"
import { Error, Excedente, PCErrorBlack } from "../../assets/icons/dashboard";
import { ThemeContext } from "../../theming";
import { columnasContratos, columnasCuotaPagos } from "../../constants/columnasTablas";
import { Card, Row, Col, Button, Container } from 'react-bootstrap';
import ButtonProgreso from '../buttons/Button'
import CardNegocio from '../cards/CardNegocio';
import Tabla from '../tabla/Tabla';
import { equalsIgnoreOrder } from '../../helpers/utils';
import { validateEmail } from "../../helpers/validators";
import Loading from '../loading/Loading';
import { Link, useOutletContext, useSearchParams } from 'react-router-dom';
import { WEB_PROGRESO, PORTALSAPI,APIINTEGRACION } from "../../helpers/url";
import eye from "../../assets/images/eye.png";
import eye2 from "../../assets/images/eye2.png";
import Cloud from "../../assets/icons/cloud.svg";
import {
    mobileXSWidth,
    mobileSMWidth,
  } from "../../helpers/responsiveVariables";
import Advertencia from '../../assets/images/advertencia.png';
const modalInfo = {
    title: "",
    subtitle: "",
    icon: null,
    size: "xl",
    content: null,
    table: { columns: [], rows: [] },
    tables: [],
  };

function Paso1() {
    const { width } = useWindowDimensions();

    const icons = {
        cuotas: <Excedente />
    }
    const app = useContext(ThemeContext);
    const { body25, body28, body32 } = app.theme.font;

    const [mediosPagos, setMediosPagos] = useState([]);

    const [medioPagoSelected, setMedioPagoSelected] = useState({});
    const [modal, setModal] = useState(modalInfo);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [showLoading, setShowLoading] = useState({ display: 'none' });
    const [showModalError, setShowModalError] = useState(false);
    const [modalData, setModalData] = useState({});
    const [hlMaxPay, setHlMaxPay] = useState(false);//Highlight para resaltar texto de detalle del medio de pago seleccionado cuando se excede el pago máximo
    const [hlBlock, setHlBlock] = useState(false);
    const [tablaContratos, setTablaContratos] = useState({
        columns: columnasContratos,
        rows: []
    });
    const [invalidCorreo, setInvalidCorreo] = useState(false);
    const [focusCorreo, setFocusCorreo] = useState(React.createRef());//Referencia para cambiar el focus al correo cuando se da a Pagar y el correo es inválido
    const focusText = React.createRef(null);//Referencia para cambiar el focus al texto de detalle del medio de pago seleccionado cuando se excede el pago máximo
    const focusTextBlock = React.createRef(null);
    const [textCorreoInvalid, setTextCorreoInvalid] = useState("");
    const optionTextCorreoInvalid = {
        Formato: "Formato inválido.",
        Vacio: "Recuerde llenar el campo de correo."
    }
    const [allContratos, setAllContratos] = useState({});
    const [cuotasSelected, setCuotasSelected] = useState([]);
    const [correoCliente, setCorreoCliente] = useState("");
    const [subTotal, setSubtotal] = useState(0);
    const [bloqueados, setBloqueados] = useState([]);
    const [tiempoBloqueo, setTiempoBloqueo] = useState({});
    const [textBlock, setTextBlock] = useState("");

    const [xml1, setXML1] = useState({
        headers: {
            CodigoCanalPago: 0,
            RutCliente: JSON.parse(localStorage.getItem("user"))?.r,
            NombreCliente : JSON.parse(localStorage.getItem("user"))?.n,
        },
        documentos: {},
        selected: [],
        publico: JSON.parse(localStorage.getItem("user"))?.w
    });
    const ButtonTry = ({message})=>{
        if(message?.includes("Ups")){
            return <a href={WEB_PROGRESO}>
            <ButtonProgreso sizeText={1} styleText={{ fontWeight : "600"}}>
                Volver al intentar
            </ButtonProgreso>
        </a>
        }else{
        return <ButtonProgreso 
                    onClick={()=>{
                        let rut = JSON.parse(localStorage.getItem("user"))?.r;
                        let tipo = JSON.parse(localStorage.getItem("user"))?.w;
                        getContratos(rut, tipo);
                    }} 
                    sizeText={1} 
                    styleText={{ fontWeight : "600"}}>
            Reintentar
        </ButtonProgreso>
        }
    }
    const handleCloseModalError = () => { setShowModalError(false) };

    const handleShowModalError = () => { setShowModalError(true) }

    const cronograma = (data) => {
        let user = JSON.parse(localStorage.getItem("user"));
        let tipo = user?.w;
    
        if (user === null) {
          window.location.href = "/";
          return;
        }
    
        let url = APIINTEGRACION.GET.EXPORTAR_CRONOGRAMA.replace(
          "{nroperacion}",
          data.nroperacion
        ).replace("{rut}", data.rut).replace("{tipo}",tipo);
        setShowLoading({ display: "block" });
        api
          .get(url)
          .then((x) => {
            console.log(x)
            const linkSource = `data:application/pdf;base64,${x.data.data.archivo}`;
            const downloadLink = document.createElement("a");
            const fileName = x.data.data.nombre;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          })
          .catch((ex) => {
            setModalData({
              messageLine: false,
              title: "Generar Cronograma",
              color: "red",
              //subtitle: "Error",
              message: "No se pudo generar el cronograma.",
              icon: (
                <>
                  <Error />
                </>
              ),
            });
            handleShowModalError();
          })
          .finally(() => {
            setShowLoading({ display: "none" });
          });
      };
      const openPDFFactura = async (tipodoc, folio, tipores) => {
        let url = PORTALSAPI.POST.OBTENERURLFACTURA;
            let body = {
          tipodoc,
          folio,
          tipores,
        };
        try {
          setShowLoading({ display: "block" });
          const { data } = await api.post(url, body);
          window.open(data.data , "_blank");
        } catch (error) {
          setModalData({
            messageLine: false,
            title: "Recuperar Factura",
            color: "red",
            subtitle: "Error",
            message: "No se pudo encontrar la factura.",
            icon: (
              <>
                <Error />
              </>
            ),
          });
          handleShowModalError();
        } finally {
          setShowLoading({ display: "none" });
        }
      };
    const openModal = async (data_modal) => {
        setShowLoading({ display: "block" });
        let type = data_modal.title;
        const _modalInfo = { table: { columns: [], rows: [] }, tables: [] };
        _modalInfo["size"] = "xl";
        _modalInfo["padding"] = true;
        _modalInfo["buttonsHeader"] = null;
        let data = [];
        switch (type) {
            case "cuotas":{
                const user = JSON.parse(localStorage.getItem("user"));
                let tipo = user?.w;
        
                if (user === null) {
                  window.location.href = "/";
                  return;
                }
                _modalInfo["search"] = true;
                _modalInfo["title"] = <Title title="Cuotas" subtitle="Pagos" />;
                _modalInfo["buttonsHeader"] = (
                    <button
                    type="button"
                    className="btn mb-2 w-auto"
                    style={{
                        marginRight: 46,
                        fontWeight: 400,
                        backgroundColor: "rgb(253, 209, 53)",
                    }}
                    onClick={() =>
                        cronograma({
                            nroperacion: data_modal.data,
                            rut: user.r,
                        })
                    }
                    >
                    Cronograma
                    <img src={Cloud} alt="" height="32px" style={{ marginLeft : 12}}/>
                  </button>
                );
                _modalInfo["subtitle"] = "En esta sección se mostrará el detalle de las cuotas y podrás descargar el cronograma respectivo.";
                _modalInfo["filas"] = 10;
                _modalInfo["table"]["columns"] = columnasCuotaPagos;
        
                let url = APIINTEGRACION.GET.CUOTAS.replace(
                  "{nroperacion}",
                  data_modal.data
                ).replace("{rut}", user.r).replace("{tipo}",tipo);
                const { data } = await api.get(url);
                  let dataT = data.data.map((el) => ({ ...el }));
                  dataT.forEach((el) => {
                    let factura = Number(el.factura);
                    let tipodoc = Number(el.tipodoc);
                    el["valor"] = (
                      <NumberFormat
                        className="pull-right"
                        value={el.valor}
                        displayType={"text"}
                        prefix={el["moneda"]}
                        thousandSeparator={"."}
                        decimalScale={2}
                        decimalSeparator={","}
                      />
                    );
                    el["total"] = `${el["numero"]}/${el["total"]}`;
                    el["factura"] =
                      factura === 0 ? (
                        <span>{factura}</span>
                      ) : (
                        <span
                          onClick={() => openPDFFactura(tipodoc, factura, 2)} // 2 : Obtiene URL de PDF
                          style={{
                            cursor: "pointer",
                            color: "blue",
                            textDecoration: "underline",
                          }}
                        >
                          {factura}
                        </span>
                      );
                  });
                  _modalInfo["table"]["rows"] = dataT;
                  _modalInfo["icon"] = icons[type];
                  setModal(_modalInfo);
                  setShowLoading({ display: "none" });
                  handleShow();
                break;
              }

            default:
                break;
        }
        
    }
    const getContratos = async (rut, web) => {
        try {
            handleCloseModalError();
            setShowLoading({ display: 'block' });
            const { data } = await api.get(`${APIINTEGRACION.GET.CONTRATOS}${rut}/${web}`);
            setMediosPagos(data.data.pasarelas);
            let blocks = data.data.deudas_cuotas.filter(d=>d.bloqueado);
            if(blocks.length > 0){
                setBloqueados(blocks);
                let tB = blocks.reduce((m,a)=>{
                    if(a.tiempo_bloqueo > m.tiempo_bloqueo){
                        return a;
                    }else{
                        return m;
                    }
                });
                setTiempoBloqueo(tB)
                setTextBlock(`Estas cuotas se encuentran congeladas; se volverán a activar en ${tB?.tiempo_bloqueo} min o hasta la confirmación del pago de su entidad financiera. Culminado este periodo podrá continuar con sus pagos.`);
            }
                
            let dataSorted = data.data.deudas_cuotas.sort((a, b) => {
                if(a.fe_pago == b.fe_pago){
                    if (a.nu_operacion == b.nu_operacion) {
                        return a.nu_cuota > b.nu_cuota ? 1 : -1
                    } else {
                        return (a.nu_operacion > b.nu_operacion) ? 1 : (b.nu_operacion > a.nu_operacion ? -1 : 0)
                    }
                }else{
                    return (a.fe_pago > b.fe_pago) ? 1 : (b.fe_pago > a.fe_pago ? -1 : 0)
                }
            });
            let objAllContratos = {};
            let array = [];
            dataSorted.forEach(element => {
                if (element.nu_cuota !== 0) {//Agrupa contratos con todas sus cuotas recuperadas
                    objAllContratos[element.nu_operacion] = objAllContratos[element.nu_operacion] ? [...objAllContratos[element.nu_operacion], element.nu_cuota] : [element.nu_cuota];
                }
                element["nu_operacion_txt"] = <>{element.nu_operacion}{element.bloqueado && <img src={Advertencia}
                alt="Advertencia"
                width="20px"
                height="20px"
                style={{ marginRight : 4}}/>}</>
                element["fe_pago"] = format(new Date(element.fe_pago), "dd/MM/yyyy");
                element["tx_cuota"] = `${element.tx_cuota}`;
                element["mt_cuota"] = <NumberFormat
                    value={element.mt_cuota}
                    displayType='text'
                    prefix="$"
                    thousandSeparator="."
                    decimalScale={2}
                    decimalSeparator=","
                />
                element["mt_interes_mora"] = <NumberFormat
                    value={element.mt_interes_mora}
                    displayType='text'
                    prefix="$"
                    thousandSeparator="."
                    decimalScale={2}
                    decimalSeparator=","
                />
                element["mt_gasto_cobranza"] = <NumberFormat
                    value={element.mt_gasto_cobranza}
                    displayType='text'
                    prefix="$"
                    thousandSeparator="."
                    decimalScale={2}
                    decimalSeparator=","
                />
                element["mt_total_a_pagar"] = <NumberFormat
                    value={element.mt_total_a_pagar}
                    displayType='text'
                    prefix="$"
                    thousandSeparator="."
                    decimalScale={2}
                    decimalSeparator=","
                />
                element["cuotapago"] = (<img
                alt=""
                width={width > mobileSMWidth ? "33px" : "40px"}
                height={width > mobileSMWidth ? "33px" : "40px"}
                onClick={() => openModal({ title: "cuotas", data: element.nu_operacion })}
                src={eye2}
                onMouseOver={(e) => (e.currentTarget.src = eye)}
                onMouseOut={(e) => (e.currentTarget.src = eye2)}
              />)
                array.push(element);
            })
            setAllContratos(objAllContratos)
            setTablaContratos({
                ...tablaContratos,
                rows: [...array]
            });
            setXML1({
                ...xml1,
                headers: {
                    ...xml1.headers,
                    CodigoCanalPago: data.data.pasarelas.find(medio => medio.pre_select == 1).codCanalPago
                }
            })

            setMedioPagoSelected(data.data.pasarelas.find(medio => medio.pre_select));
        } catch (error) {
            setModalData({
                messageLine: false,
                //title: "Pagar contratos",
                color: "red",
                //subtitle: "Error",
                message: error.response.data.message,
                icon: (
                    <>
                        <PCErrorBlack />
                    </>
                ),
                buttonTry : ()=><ButtonTry message={error.response.data.message}/>
            });
            handleShowModalError();
        } finally {
            setShowLoading({ display: 'none' });
        }
    }
    useEffect(() => {
        let rut = JSON.parse(localStorage.getItem("user"))?.r;
        let tipo = JSON.parse(localStorage.getItem("user"))?.w;
        getContratos(rut, tipo);
    }, [])
    useEffect(() => {
        setInvalidCorreo(false);
    }, [correoCliente])
    /* const onExpandedContrato = (expanded, row) => {
        if (expanded) {
          setidContratoExpanded(row.contrato);
        } else {
            //setCuotasSelected([]);
            cuotasVar = [];
        }
      } */
    /* const expandedContrato = (row) =>idContratoExpanded === row.contrato
  */
    const rowDisabledCriteria = row=>row.bloqueado;
    const handleCuotasSelect = ({ selectedRows }) => {
        const selected = selectedRows.map(o=>{
            const { cuotapago, nu_operacion_txt, ...r} = o;
            return r;
        })
        setCuotasSelected(selected);
        setXML1({
            ...xml1,
            documentos: {
                ...xml1.documentos,
                FechaVencimiento: selected.length ? format(new Date(Math.min.apply(null, selected.map(item => moment(item.fe_pago,"DD/MM/YYYY").toDate()))), "yyyyMMdd") : "",
            },
            selected: selected.sort((a,b)=>{if(a.nu_operacion===b.nu_operacion){return a.nu_cuota - b.nu_cuota}else{return a.nu_operacion - b.nu_operacion}}).map(cuota => ({ 
                ...cuota,
                mt_total_a_pagar: cuota.mt_total_a_pagar.props.value,
                mt_cuota : cuota.mt_cuota.props.value,
                mt_interes_mora : cuota.mt_interes_mora.props.value,
                mt_gasto_cobranza : cuota.mt_gasto_cobranza.props.value
            }))
        })
    };
    const validateCuotasSelected = () => {//Validar lógica de seleccionar cuotas en orden y sin saltear uno anterior.
        let objCuotasSelected = {};
        let deudaSelected = false;
        let contratosSelected = [... new Set(cuotasSelected.map(c => c.nu_operacion))];//Contratos seleccionados
        cuotasSelected.forEach(cuota => {//Objeto de [op] : [Array[nu_cuotas]] seleccionadas
            if (cuota.nu_cuota !== 0) {
                objCuotasSelected[cuota.nu_operacion] = objCuotasSelected[cuota.nu_operacion] ? [...objCuotasSelected[cuota.nu_operacion], cuota.nu_cuota] : [cuota.nu_cuota];
            } else {
                deudaSelected = true;
            }
        });
        let contratosCondicion = {};
        //objCuotasSelected.forEach(contrato=>{contratosCondicion[contrato] = true});
        let contratosCondicionFalse = [];
        for (const property in objCuotasSelected) {//Recorrido por todos los contratos seleccionados
            let objCuotasSelectedSorted = objCuotasSelected[property].sort();

            let maxCuota = Math.max(...objCuotasSelectedSorted);
            let arrayAllContratosFiltered = allContratos[property].filter(element => element <= maxCuota).sort();//Array de todas cuotas de la op menores al máximo seleccionado
            if (!equalsIgnoreOrder(objCuotasSelectedSorted, arrayAllContratosFiltered)) {//Valida si ambos array son iguales
                contratosCondicion[property] = false;
                contratosCondicionFalse.push(property);
            } else {
                contratosCondicion[property] = true;
            }
        }

        if (contratosCondicionFalse.length != 0) {
            if (contratosSelected.length > 1) {
                return <>{`Contrato ${contratosCondicionFalse.toString()}:`}
                    <br />
                    {"Si desea abonar  a sus deudas y cuotas en un  mismo pago,  seleccione las cuotas más antiguas cronológicamente."}
                </>
            } else {
                if (deudaSelected) {
                    return `Si desea abonar  a sus deudas y cuotas en un  mismo pago,  seleccione las cuotas más antiguas cronológicamente.`
                } else {
                    return `Para proceder con su pago debe seleccionar la cuota más antigua. De no poder realizarse el pago, comuníquese con su ejecutivo asignado.`
                }
            }
        } else {
            return "";
        }
    }
    const validaCuotaBloqueadaYCuotaMayorSeleccionada = () => {//Validar lógica de seleccionar cuotas en orden y sin saltear uno anterior.
        let objCuotasSelected = {};
        let deudaSelected = false;
        cuotasSelected.forEach(cuota => {//Objeto de [op] : [Array[nu_cuotas]] seleccionadas
            if (cuota.nu_cuota !== 0) {
                objCuotasSelected[cuota.nu_operacion] = objCuotasSelected[cuota.nu_operacion] ? [...objCuotasSelected[cuota.nu_operacion], cuota.nu_cuota] : [cuota.nu_cuota];
            } else {
                deudaSelected = true;
            }
        });
        let contratosCondicion = {};
        //objCuotasSelected.forEach(contrato=>{contratosCondicion[contrato] = true});
        let contratosCondicionFalse = [];
        for (const property in objCuotasSelected) {//Recorrido por todos los contratos seleccionados
            let objCuotasSelectedSorted = objCuotasSelected[property].sort();

            let maxCuota = Math.max(...objCuotasSelectedSorted);
            let arrayAllContratosFiltered = allContratos[property].filter(element => element <= maxCuota).sort();//Array de todas cuotas de la op menores al máximo seleccionado
            if (!equalsIgnoreOrder(objCuotasSelectedSorted, arrayAllContratosFiltered)) {//Valida si ambos array son iguales
                contratosCondicion[property] = false;
                contratosCondicionFalse.push(property);
            } else {
                contratosCondicion[property] = true;
            }
        }
        if (contratosCondicionFalse.length != 0) {
            if(contratosCondicionFalse.some(F=>tablaContratos.rows.filter(t=>t.nu_operacion === Number(F)).some(v=>v.bloqueado))){
                return true
            }
        }
        return false;
    }
    const highLightText = () => {
        setHlMaxPay(true);
        setTimeout(() => setHlMaxPay(false), 1500)
    }
    const highLightTextBlock = () => {
        setHlBlock(true);
        setTimeout(() => setHlBlock(false), 1500)
    }
    const handleBlurCorreo = () => {
        if (!validateEmail(correoCliente)) {
            setInvalidCorreo(true);
            setTextCorreoInvalid(optionTextCorreoInvalid.Formato);
        }
        if (correoCliente == "") {
            //setFocusCorreo(true);
            setInvalidCorreo(true);
            setTextCorreoInvalid(optionTextCorreoInvalid.Vacio);
        }
    }
    const onPagar = (e) => {
        let message = "";
        if(bloqueados.length > 0 ){
            setTextBlock(`Tiene cuotas que se encuentran congeladas; estas se volverán a activar en ${tiempoBloqueo?.tiempo_bloqueo} min o hasta la confirmación del pago de su entidad financiera. Culminado este periodo podrá continuar con sus pagos.`);
            focusTextBlock.current.scrollIntoView(false);
            highLightTextBlock();
            e.preventDefault();
            return;
        }
        if (xml1.headers.CodigoCanalPago === 0) {
            message = "Debe seleccionar un método de pago.";
        }
        let validaBloqueadsNoSeleccionadas = validaCuotaBloqueadaYCuotaMayorSeleccionada();
        let textValidateCuotas = validateCuotasSelected();
        if (textValidateCuotas != "") {
            message = textValidateCuotas;
        }
        /* if(Number(xml1.headers.MontoTotalDeuda) > medioPagoSelected.max_pay && medioPagoSelected.max_pay !== 0){
            //message = "No debe exceder al máximo de pago del medio de pago seleccionado.";
            focusText.current.scrollIntoView();
        } */
        if (message !== "" && !validaBloqueadsNoSeleccionadas) {
            setModalData({
                messageLine: false,
                //title: "Pagar contratos",
                color: "red",
                //subtitle: "Error",
                message,
                icon: (
                    <>
                        <PCErrorBlack />
                    </>
                ),
            });
            handleShowModalError();
            e.preventDefault();
        } else {
            if (Number(xml1.headers.MontoTotalDeuda) > medioPagoSelected.max_pay && medioPagoSelected.max_pay !== 0) {
                //message = "No debe exceder al máximo de pago del medio de pago seleccionado.";
                focusText.current.scrollIntoView(false);
                highLightText();
                e.preventDefault();
            } else {
                if(validaBloqueadsNoSeleccionadas){
                    focusTextBlock.current.scrollIntoView(false);
                    highLightTextBlock();
                    e.preventDefault();
                }
                if (!validateEmail(correoCliente)) {
                    focusCorreo.current.focus();
                    //setFocusCorreo(true);
                    setInvalidCorreo(true);
                    setTextCorreoInvalid(optionTextCorreoInvalid.Formato);
                    e.preventDefault();

                }
                if (correoCliente == "") {
                    focusCorreo.current.focus();
                    //setFocusCorreo(true);
                    setInvalidCorreo(true);
                    setTextCorreoInvalid(optionTextCorreoInvalid.Vacio);
                    e.preventDefault();

                }
            }

        }
    }
    const calculateSubTotal = () => {
        const subTotal = cuotasSelected.map(cuota => (cuota.mt_total_a_pagar.props.value))
            .reduce((a, b) => a + b, 0);
        setSubtotal(Math.round(subTotal * 100) / 100);
        setXML1({
            ...xml1,
            headers: {
                ...xml1.headers,
                MontoTotalDeuda: Math.round(subTotal).toString(),
            },
            documentos: {
                ...xml1.documentos,
                Monto: Math.round(subTotal * 100) / 100
            }
        });
    }
    const onChangeMediosPagos = (e) => {
        setXML1({
            ...xml1,
            headers: {
                ...xml1.headers,
                CodigoCanalPago: Number(e.target.value)
            }
        })
        setMedioPagoSelected(mediosPagos.find(medio => medio.codCanalPago == e.target.value))
    }
    const handlePreSelected = row => false
    useEffect(() => calculateSubTotal(), [cuotasSelected])
    useEffect(() => setXML1({
        ...xml1,
        headers: {
            ...xml1.headers,
            EmailCliente: correoCliente
        }
    }), [correoCliente])
    const getTextMedioPago = () => {
        var text = "";
        text = medioPagoSelected?.text_info;
        if (medioPagoSelected?.max_pay !== 0 && text !== undefined) {
            var textArray = text.split("MAX_PAY");
            textArray.forEach((segment, i) => {
                if (i == 0) {
                    text = (<>{segment}</>);
                } else {
                    text = <>{text}<NumberFormat
                        value={medioPagoSelected.max_pay}
                        displayType='text'
                        prefix="$"
                        thousandSeparator="."
                        decimalScale={2}
                        decimalSeparator=","
                    />{segment}</>;
                }
            })
        }
        return text;
    }
    return (
        <>
            <Loading estilo={showLoading}></Loading>

            <Row
                className="mt-4"
                style={{ width: width >= 701 ? "87%" : "100%" }}
            >
                <Col>

                    <Card>
                        <Card.Body>
                            <CardNegocio
                                icon={icons.cuotas}
                                title='Cuotas/Pagos'
                                data={tablaContratos.rows}
                                table={<Tabla
                                    numeroFilas={10}
                                    textNoData="No existen cuotas o deudas pendientes a mostrar"
                                    busqueda={true}
                                    datos={tablaContratos}
                                    paginacion={true}
                                    direction="rtl"
                                    inputType="checkbox"
                                    selectableRows={true}
                                    onSelectedRowsChange={handleCuotasSelect}
                                    selectableRowDisabled={rowDisabledCriteria }
                                //selectableRowSelected={handlePreSelected}
                                />}
                                text={getTextMedioPago()}
                                focusText={focusText}
                                focusTextBlock={focusTextBlock}
                                hlMaxPay={hlMaxPay}
                                textBlock={textBlock}
                                hlBlock={hlBlock}
                                mediosPagos={mediosPagos}
                                subTotal={subTotal}
                                invalidCorreo={invalidCorreo}
                                handleBlurCorreo={handleBlurCorreo}
                                focusCorreo={focusCorreo}
                                textCorreoInvalid={textCorreoInvalid}
                                setCorreoCliente={setCorreoCliente}
                                correoCliente={correoCliente}
                                onChangeMediosPagos={onChangeMediosPagos}
                                medioPagaSelected={xml1.headers.CodigoCanalPago}
                                buttonPagar={<Link to="resumen" state={{ xml1, medioPagoSelected }}
                                    style={{ pointerEvents: !!cuotasSelected.length ? "" : "none", width: "auto" }}
                                    onClick={onPagar}
                                >
                                    <ButtonProgreso
                                        className='noprint'
                                        disabled={!cuotasSelected.length}
                                        sizeText={1}>
                                        Ir a Pagar
                                    </ButtonProgreso>
                                </Link>}
                                progress={33}
                                bloqueados={bloqueados.length > 0}
                            /* <Row>
                               <Col>
                               Transferencia Bancaria
                               </Col>
                               <Col>
                               Medio Pago
                               </Col>
                            </Row>
                            <Row>
                                <Col>
                                Total a Pagar: ${Math.round(subTotal * 100 ) / 100}</Col>
                            </Row> */
                            />

                        </Card.Body>
                        {/* Table with MUI */}
                        {/* <Row>
                    <Col>
                        <Card>
                            <Card.Body>
                                <TableMUI 
                                    datos={tablaContratos}
                                    collapsible={true}
                                    collapsibleAutoHidden={false}
                                    columnsCollapsive={columnasCuotas}
                                    selectableCollapsible={true}
                                    rowCollapsive="cuotas"
                                    positionSelectableCollapsive='end'
                                    onSelectedChange={({selected})=>setCuotasSelected(selected)}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                 </Row>
                 <Row>
                     <Col>
                     {subTotal}</Col>
                 </Row>
                 <Row xs={12}>
                     <Button onClick={onPagar}>Pagar</Button>
                 </Row>
                 <Row xs={12}>
                     <Col>
                     <Button onClick={onSaveCorreo}>Guardar</Button>
                     </Col>
                     <Col>
                     <input value={inputCorreo} onChange={(e)=>setInputCorreo(e.target.value)}/>
                     </Col>
                     {inputCorreo && <Col>
                     <span>{correoCliente}</span>
                     </Col>}
                      <Col>
                     <span>{cuotasVar}</span>
                     </Col>
                 </Row> */}
                    </Card>
                </Col>
            </Row>
            <Modal
                  padding={modal.padding}
                  size={modal.size}
                  show={show}
                  icon={modal.icon}
                  title={modal.title}
                  subtitle={modal.subtitle}
                  handleClose={handleClose}
                >
                  {modal.table ? (
                    <>
                      {modal.buttonsHeader && (
                        <div className="row justify-content-end">
                          {modal.buttonsHeader}
                        </div>
                      )}
                      <Tabla
                        paginacion={true}
                        numeroFilas={modal.filas ? modal.filas : 5}
                        busqueda={!!modal.search}
                        datos={modal.table}
                      ></Tabla>
                    </>
                  ) : !modal.tables?.length ? (
                    modal.content
                  ) : (
                    <div className="container">
                      <div className="row justify-content-end">
                        {modal.buttonsHeader}
                      </div>
                      <div className="row row-cols-1 row-cols-lg-2">
                        {modal.tables.map((table) => (
                          <div className="col mb-2">
                            <Title pipe={false} title={table.title} subtitle="" />
                            <Tabla
                              paginacion={true}
                              numeroFilas={5}
                              busqueda={!!table.search}
                              datos={table}
                            ></Tabla>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
            </Modal>
            <ModalWebPagos
                show={showModalError}
                icon={modalData.icon}
                headerTitle="Pago en Línea"
                messageLine={modalData.messageLine}
                title={
                    <TextColored size={body28} type={modalData.color} style={{textAlign : "center"}}>
                        {modalData.title}
                    </TextColored>
                }
                subtitle={
                    <TextColored size={body32} bold type={modalData.color} style={{textAlign : "center"}}>
                        {modalData.subtitle}
                    </TextColored>
                }
                message={
                    <Text type="primary" size={body25} style={{ fontWeight : "600",textAlign : "center"}}>
                        {modalData.message}
                    </Text>
                }
                handleClose={handleCloseModalError}
                ButtonTry={modalData.buttonTry}
            />
        </>
    )
}


export default Paso1;
